import ReceiptsGrid from './ReceiptsGrid';

export default ReceiptsGrid;
